import React, { useState } from "react";
import More from "../../../Components/Icons/More";
import axiosInstance from "../../../Services/axiosCommon";
import { GetAccess } from "../../../Components/Utils/roles";
import { Modal, notification } from "antd";
import ModalContainer from "../../../Components/Others/ModalContainer";
import ViewEmailSent from "../../Web/E-Mail/EmailSent/ViewEmailSent";

const ViewMoreEmail = ({ data, getData, id }) => {
  const canDelete = GetAccess("email_delete");
  const [api, contextHolder] = notification.useNotification();
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);

  // Delete handler
  const handleDelete = async () => {
    try {
      const res = await axiosInstance.delete(`/PO/${id}`);
      if (res.status === 200 || res.status === 201) {
        getData();
        api.success({
          message: "Deleted successfully",
          description: res?.data?.msg || "",
          placement: "bottomRight",
        });
      } else {
        api.error({
          message: "Delete failed",
          description: res?.data?.msg || "Network error",
          placement: "bottomRight",
        });
      }
    } catch (error) {
      api.error({
        message: "Delete failed",
        description:
          error?.response?.data?.msg || "Server error (or) Network error",
        placement: "bottomRight",
      });
    } finally {
      setIsDeleteModalOpen(false);
    }
  };

  const showViewModal = () => {
    setIsViewModalOpen(true);
  };

  const handleCloseViewModal = () => {
    setIsViewModalOpen(false);
  };

  return (
    <>
      {contextHolder}
      <div className="text-[#344767] relative dropdown inline-block z-50">
        <div className="cursor-pointer text-xs mx-auto font-semibold flex items-center">
          <span
            className="w-7 h-7 bg-gray-50 flex items-center justify-center rounded-full"
            style={{ border: "1px solid #C0C0C0" }}
          >
            <More />
          </span>
        </div>

        <ul className="dropdown-menuOne text-[#344767] text-left rounded-lg absolute -left-[80px] -top-4 overflow-hidden hidden z-50 shadow-lg">
          {/* View */}
          <li className="w-[100px] bg-black block m-0">
            <span
              className="bg-white hover:bg-gray-100 py-2 px-2 block whitespace-no-wrap text-xs font-medium text-black cursor-pointer"
              // onClick={() => setIsViewModalOpen(true)}
              onClick={showViewModal}

            >
              View
            </span>
          </li>

          {/* Delete */}
          {canDelete && (
            <li>
              <button
                className="w-full text-left bg-white hover:bg-gray-100 text-black py-2 px-2 block whitespace-no-wrap text-xs font-medium"
                onClick={() => setIsDeleteModalOpen(true)}
              >
                Delete
              </button>
            </li>
          )}
        </ul>
      </div>

      {/* View Modal */}
       {/* Popup Modal with styled content */}
      <Modal
        title="Email Details"
        open={isViewModalOpen}
        onCancel={handleCloseViewModal}
        footer={null}
        centered
        width={700}
        bodyStyle={{ paddingTop: 0 }}
      >
        <ViewEmailSent item={data} />
      </Modal>

      {/* Delete Confirmation Modal */}
      <ModalContainer
        visiable={isDeleteModalOpen}
        title="Warning"
        content={`Are you sure you want to delete ${data?.subject}?`}
        handleClick={handleDelete}
        closeModal={() => setIsDeleteModalOpen(false)}
      />
    </>
  );
};

export default ViewMoreEmail;
